import React from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";

const SFIconButton = ({
  children,
  variant,
  size,
  type,
  onClick,
  edge,
  ariaLabel = null,
  ...props
}) => (
  <IconButton
    variant={variant}
    size={size}
    type={type}
    onClick={onClick}
    edge={edge}
    aria-label={ariaLabel}
    {...props}
  >
    {children}
  </IconButton>
);

SFIconButton.defaultProps = {
  variant: "contained",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  edge: false,
};

SFIconButton.propTypes = {
  edge: PropTypes.oneOf(["end", "start", false]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "contained",
    "outlined",
    "text",
    "text-alt",
    "unhovered",
    "toolbar",
    "transparent",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  disabled: PropTypes.bool,
};

export default SFIconButton;
